module.exports = __webpack_public_path__ + "img/motorcycle.be5030ca.webp";